<template>
  <button-card-config
    v-for="design in meshEngravings"
    :key="design.fileId"
    :title="safeT({t:this.$t, category:'designs', keyName:design.thumbnail?.name || '-'})"
    @click="emitMeshDesignSelected(design)"
    class="card-custom"
    :class="{ active: isSelected(design.fileId) }"
  >
    <!-- Display thumbnail if available -->
    <img v-if="design.thumbnail?.content" :src="design.thumbnail?.content" alt="Design Thumbnail" class="design-thumbnail" />
    <div v-else class="design-thumbnail"></div>
  </button-card-config>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import ButtonCardConfig from '../layout/ButtonCardConfig.vue';
import { SupportedValues } from '@/types/api/Utility/SupportedValues';
import { useComponentSettingStore } from '@/utils/componentSettings';
import { safeT } from '@/utils/text';

@Component({
  components: {
    ButtonCardConfig,
  },
  emits: ['meshDesignSelected'],
})
@Component
export default class MeshDesignSelector extends Vue {
  // Props
  @Prop({ default: false }) multiple!: boolean;
  @Prop({ default: [] }) selectedMultipleEngraving!: number[];
  @Prop({ required: true }) selectedEngraving!: number | number[];
  @Prop({ default: [] }) meshEngravings!: SupportedValues[];

  multipleEngraving: SupportedValues[] = [] 
  settingStore = useComponentSettingStore();
  safeT = safeT;

  isSelected(fileId: number | null): boolean {
    if (!fileId) return false;

    if (this.multiple && Array.isArray(this.selectedEngraving)) {
      return this.selectedEngraving.includes(fileId)
    } else {
      return this.selectedEngraving === fileId
    }
  }

  // Emit methods
  emitMeshDesignSelected(design: SupportedValues) {
    if(this.multiple) {
      const find = this.multipleEngraving.find(item => item.fileId === design.fileId);
      
      if (find) {
        const designs = this.multipleEngraving.filter(item => item.fileId !== find.fileId)
        this.multipleEngraving = designs;
        this.$emit('meshDesignSelected', designs);
        return;
      }
      const designs =  [...this.multipleEngraving, design]
      this.multipleEngraving = designs
      this.$emit('meshDesignSelected', designs);
    } else {
      this.$emit('meshDesignSelected', design);
      // localStorage.setItem('orderDesign', design.thumbnail?.name ?? '');
      const designKey = design.thumbnail?.name ?? '';
      if (designKey) {
        this.settingStore.saveConfig({ embossing: designKey });
      }
    }
  }
}
</script>

<style lang="scss">
.scroll-wrapper::-webkit-scrollbar {
  height: 8px;
}
.scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
.scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.design-thumbnail {
  height: 3rem !important;
  object-fit: cover;
  max-width: 95%;
}

.card-custom {
  width: 130px !important;
  height: 130px !important;
  cursor: pointer;
}

.card {
  border-color: #1d1e19 !important;
  border-width: 2px !important;
  transition: all 0.1s ease-in-out;
  padding: 2px;
}

.card.active {
  border-color: #b20000 !important;
  border-width: 4px !important;
  padding: 0px;
}

.card:hover {
  transform: scale(1.03);
}

.rounded-circle {
  height: 48px !important;
  width: 48px !important;
}
</style>
